import React from 'react'


const PaidForBy = (props) => (
  <div className='paid-for-by bg-base1 color-base2 font-0 py-1 mb-2 mb-lg-0 px-2'>Paid for by Cabán for Council</div>
)

export default PaidForBy
